// SEQ-240 audit B, rows 7 and 29: "Overtime % revenue" divides payroll overtime
// by the income of EVERY project, but a project with no payroll mapping has no
// overtime figure at all (null, never zero). The card keeps today's number and
// its pop-up also shows this one: the same ratio over the projects that have a
// payroll mapping. Pure module, no React.

import type { PnlRollup } from "./rollup";

/** A project's overtime is null when it has no payroll mapping. */
type RollupLike = Pick<PnlRollup, "revenue" | "overtime">;

export interface MappedOnlyOvertime {
  /** Overtime over revenue, times 100, across mapped projects only. Null when no mapped project has revenue. */
  pct: number | null;
  mappedCount: number;
  unmappedCount: number;
}

export function mappedOnlyOvertimePctRevenue(projects: readonly RollupLike[]): MappedOnlyOvertime {
  let overtime = 0;
  let revenue = 0;
  let mappedCount = 0;
  let unmappedCount = 0;
  for (const project of projects) {
    if (project.overtime === null) {
      unmappedCount++;
      continue;
    }
    mappedCount++;
    overtime += project.overtime;
    revenue += project.revenue;
  }
  return { pct: revenue > 0 ? (overtime / revenue) * 100 : null, mappedCount, unmappedCount };
}
